// extracted by mini-css-extract-plugin
module.exports = {"badge":"badge-XXA5R","badge_active":"badge_active-2y280"};